import React from 'react';
import { Container, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ApplicationListTable from 'src/ui-component/ApplicationListTable/Index';
import useLoginCheck from 'src/hooks/useLoginCheck';
import Breadcrumb from 'src/ui-component/Breadcrumb';

const ApplicationList: React.FC = () => {
  useLoginCheck();
  const location = useLocation();
  const isDraft = location.pathname.split('/').pop() === 'draft-application';
  const columns = [
    'Application Number',
    'License Number',
    'Applicant Name',
    'Owner Name',
    'Pet Type',
    'Pet Name',
    'Last Activity Date',
    'Permit Expiration Date',
    'Status',
    'Actions'
  ];

  return (
    <Container sx={{ mt: 2 }} className="main-table-container">
      <Breadcrumb
        PermitName={'Pet License'}
        PageTitle={`${isDraft ? 'Draft' : 'All'} Applications`}
      />

      <Box mt={2}>
        <ApplicationListTable columns={columns} isDraft={isDraft} />
      </Box>
    </Container>
  );
};

export default ApplicationList;
